module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.c88cecb.ttf";